module.exports = __webpack_public_path__ + "static/netmarkjp-6fa91904ddd5a57c5b1ec52177e0c783.png";